import { keepPreviousData, useQuery } from "@tanstack/react-query";
import {
  CarePlanTemplate,
  RosAndPe,
} from "../../../pages/app/provider/scheduling/appointment/encounter/encounter-constant";
import { RosTemplateControllerApi } from "../../../services";
import { getConfigObject, useBaseData } from "../../../utils/utils";

interface UseSmsEmailTemplateByIdProps {
  rosTemplateUuid?: string;
  xTENANTID?: string;
}

interface ReturnType extends CarePlanTemplate {
  rosTemplateTypeSet: RosAndPe[] | null;
  description: string;
  subject: string;
}

/**
 *
 * @author Rajkumar Rathod
 */
export function useRosTemplateById({
  rosTemplateUuid,
  xTENANTID,
}: UseSmsEmailTemplateByIdProps): useBaseData<ReturnType> {
  return useQuery({
    queryKey: ["template-by-id", rosTemplateUuid, xTENANTID],
    enabled: !!rosTemplateUuid,
    refetchOnWindowFocus: false,
    placeholderData: keepPreviousData,
    queryFn: async () =>
      new RosTemplateControllerApi(getConfigObject())
        .getRosTemplateById(rosTemplateUuid!, xTENANTID)
        .then((res) => res?.data),
  });
}
